import { createSlice } from '@reduxjs/toolkit';
import { uniq } from 'ramda';

import { EMPTY_VALUES } from 'constants/general';

const initialState = {
	policyCompanyId: null,
	partnerFieldsEditable: true,
	policyFieldsEditable: true,
	documentIds: EMPTY_VALUES.ARRAY,
	taskIsBeingCreated: false,
	selectedClient: null,
	selectedPolicy: null,
};

export const taskCreatingPages = createSlice({
	name: 'taskCreatingPages',
	initialState,
	reducers: {
		setPolicyEditability: (state, { payload }) => ({
			...state,
			policyFieldsEditable: payload,
		}),
		setPartnerEditability: (state, { payload }) => ({
			...state,
			partnerFieldsEditable: payload,
		}),
		addDocumentId: (state, { payload }) => ({
			...state,
			documentIds: uniq(state.documentIds.concat(payload)),
		}),
		removeDocumentId: (state, { payload }) => ({
			...state,
			documentIds: state.documentIds.filter((id) => id !== payload),
		}),
		setTaskIsBeingCreated: (state, { payload }) => ({
			...state,
			taskIsBeingCreated: payload,
		}),
		setPolicyCompanyId: (state, { payload }) => ({
			...state,
			policyCompanyId: payload,
		}),
		setSelectedClient: (state, { payload }) => ({
			...state,
			selectedClient: payload,
		}),
		setSelectedPolicy: (state, { payload }) => ({
			...state,
			selectedPolicy: payload,
		}),
		reset: () => initialState,
	},
});

export default taskCreatingPages.reducer;
export const REDUCER_NAME = taskCreatingPages.name;

export const {
	setPartnerEditability,
	setPolicyEditability,
	addDocumentId,
	removeDocumentId,
	setTaskIsBeingCreated,
	setPolicyCompanyId,
	setSelectedClient,
	setSelectedPolicy,
	reset,
} = taskCreatingPages.actions;
